import { Injectable } from "@angular/core";
import { NgbDatepickerI18n,NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { I18n } from "./i18n.class";

const I18N_VALUES = {
    "kr":{
        weekdays:["월","화","수","목","금","토","일"]
        ,months:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"]
    }
};

@Injectable()
export class I18nDatePicker extends NgbDatepickerI18n {
    constructor(private _i18n:I18n) {
        super();
    }
    getWeekdayShortName(weekday:number):string {
        return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
    }
    getMonthShortName(month:number):string {
        return I18N_VALUES[this._i18n.language].months[month - 1];
    }
    getMonthFullName(month:number):string {
        return this.getMonthShortName(month);
    }
    getDayAriaLabel(date:NgbDateStruct):string {
        return `${date.year}-${date.month}-${date.day}`;
    }
}
